module.exports = __webpack_public_path__ + "7afee7b0534113627482050be7858f56.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/images/bio-leo-04.jpg
 ** module id = 357
 ** module chunks = 0
 **/